import EN_Black from './assets/Full/Manulife_EN/black.svg.js';
import EN_Color from './assets/Full/Manulife_EN/color.svg.js';
import EN_Reverse from './assets/Full/Manulife_EN/reverse.svg.js';
import EN_White from './assets/Full/Manulife_EN/white.svg.js';
import FR_Black from './assets/Full/Manulife_FR/black.svg.js';
import FR_Color from './assets/Full/Manulife_FR/color.svg.js';
import FR_Reverse from './assets/Full/Manulife_FR/reverse.svg.js';
import FR_White from './assets/Full/Manulife_FR/white.svg.js';
import HK_Linear_Black from './assets/Full/Manulife_HK_Linear/black.svg.js';
import HK_Linear_Color from './assets/Full/Manulife_HK_Linear/color.svg.js';
import HK_Linear_Reverse from './assets/Full/Manulife_HK_Linear/reverse.svg.js';
import HK_Linear_White from './assets/Full/Manulife_HK_Linear/white.svg.js';
import HK_Stacked_Black from './assets/Full/Manulife_HK_Stacked/black.svg.js';
import HK_Stacked_Color from './assets/Full/Manulife_HK_Stacked/color.svg.js';
import HK_Stacked_Reverse from './assets/Full/Manulife_HK_Stacked/reverse.svg.js';
import HK_Stacked_White from './assets/Full/Manulife_HK_Stacked/white.svg.js';
import JP_Linear_Black from './assets/Full/Manulife_JP_Linear/black.svg.js';
import JP_Linear_Color from './assets/Full/Manulife_JP_Linear/color.svg.js';
import JP_Linear_Reverse from './assets/Full/Manulife_JP_Linear/reverse.svg.js';
import JP_Linear_White from './assets/Full/Manulife_JP_Linear/white.svg.js';
import JP_Stacked_Black from './assets/Full/Manulife_JP_Stacked/black.svg.js';
import JP_Stacked_Color from './assets/Full/Manulife_JP_Stacked/color.svg.js';
import JP_Stacked_Reverse from './assets/Full/Manulife_JP_Stacked/reverse.svg.js';
import JP_Stacked_White from './assets/Full/Manulife_JP_Stacked/white.svg.js';
import Bank_EN_Black from './assets/Full/Manulife-Bank_EN/black.svg.js';
import Bank_EN_Color from './assets/Full/Manulife-Bank_EN/color.svg.js';
import Bank_EN_Reverse from './assets/Full/Manulife-Bank_EN/reverse.svg.js';
import Bank_EN_White from './assets/Full/Manulife-Bank_EN/white.svg.js';
import Bank_FR_Black from './assets/Full/Manulife-Bank_FR/black.svg.js';
import Bank_FR_Color from './assets/Full/Manulife-Bank_FR/color.svg.js';
import Bank_FR_Reverse from './assets/Full/Manulife-Bank_FR/reverse.svg.js';
import Bank_FR_White from './assets/Full/Manulife-Bank_FR/white.svg.js';
import CoverMe_EN_Black from './assets/Full/Manulife-CoverMe_EN/black.svg.js';
import CoverMe_EN_Color from './assets/Full/Manulife-CoverMe_EN/color.svg.js';
import CoverMe_EN_Reverse from './assets/Full/Manulife-CoverMe_EN/reverse.svg.js';
import CoverMe_EN_White from './assets/Full/Manulife-CoverMe_EN/white.svg.js';
import CoverMe_FR_Black from './assets/Full/Manulife-CoverMe_FR/black.svg.js';
import CoverMe_FR_Color from './assets/Full/Manulife-CoverMe_FR/color.svg.js';
import CoverMe_FR_Reverse from './assets/Full/Manulife-CoverMe_FR/reverse.svg.js';
import CoverMe_FR_White from './assets/Full/Manulife-CoverMe_FR/white.svg.js';
import IM_CN_Black from './assets/Full/Manulife-IM_CN/black.svg.js';
import IM_CN_Color from './assets/Full/Manulife-IM_CN/color.svg.js';
import IM_CN_Reverse from './assets/Full/Manulife-IM_CN/reverse.svg.js';
import IM_CN_White from './assets/Full/Manulife-IM_CN/white.svg.js';
import IM_EN_Linear_Black from './assets/Full/Manulife-IM_EN_Linear/black.svg.js';
import IM_EN_Linear_Color from './assets/Full/Manulife-IM_EN_Linear/color.svg.js';
import IM_EN_Linear_Reverse from './assets/Full/Manulife-IM_EN_Linear/reverse.svg.js';
import IM_EN_Linear_White from './assets/Full/Manulife-IM_EN_Linear/white.svg.js';
import IM_EN_Stacked_Black from './assets/Full/Manulife-IM_EN_Stacked/black.svg.js';
import IM_EN_Stacked_Color from './assets/Full/Manulife-IM_EN_Stacked/color.svg.js';
import IM_EN_Stacked_Reverse from './assets/Full/Manulife-IM_EN_Stacked/reverse.svg.js';
import IM_EN_Stacked_White from './assets/Full/Manulife-IM_EN_Stacked/white.svg.js';
import IM_FR_Linear_Black from './assets/Full/Manulife-IM_FR_Linear/black.svg.js';
import IM_FR_Linear_Color from './assets/Full/Manulife-IM_FR_Linear/color.svg.js';
import IM_FR_Linear_Reverse from './assets/Full/Manulife-IM_FR_Linear/reverse.svg.js';
import IM_FR_Linear_White from './assets/Full/Manulife-IM_FR_Linear/white.svg.js';
import IM_FR_Stacked_Black from './assets/Full/Manulife-IM_FR_Stacked/black.svg.js';
import IM_FR_Stacked_Color from './assets/Full/Manulife-IM_FR_Stacked/color.svg.js';
import IM_FR_Stacked_Reverse from './assets/Full/Manulife-IM_FR_Stacked/reverse.svg.js';
import IM_FR_Stacked_White from './assets/Full/Manulife-IM_FR_Stacked/white.svg.js';
import IM_JP_Black from './assets/Full/Manulife-IM_JP/black.svg.js';
import IM_JP_Color from './assets/Full/Manulife-IM_JP/color.svg.js';
import IM_JP_Reverse from './assets/Full/Manulife-IM_JP/reverse.svg.js';
import IM_JP_White from './assets/Full/Manulife-IM_JP/white.svg.js';
import IM_TW_Black from './assets/Full/Manulife-IM_TW/black.svg.js';
import IM_TW_Color from './assets/Full/Manulife-IM_TW/color.svg.js';
import IM_TW_Reverse from './assets/Full/Manulife-IM_TW/reverse.svg.js';
import IM_TW_White from './assets/Full/Manulife-IM_TW/white.svg.js';
import Private_Wealth_CN_Black from './assets/Full/Manulife-Private-Wealth_CN/black.svg.js';
import Private_Wealth_CN_Color from './assets/Full/Manulife-Private-Wealth_CN/color.svg.js';
import Private_Wealth_CN_Reverse from './assets/Full/Manulife-Private-Wealth_CN/reverse.svg.js';
import Private_Wealth_CN_White from './assets/Full/Manulife-Private-Wealth_CN/white.svg.js';
import Private_Wealth_EN_Linear_Black from './assets/Full/Manulife-Private-Wealth_EN_Linear/black.svg.js';
import Private_Wealth_EN_Linear_Color from './assets/Full/Manulife-Private-Wealth_EN_Linear/color.svg.js';
import Private_Wealth_EN_Linear_Reverse from './assets/Full/Manulife-Private-Wealth_EN_Linear/reverse.svg.js';
import Private_Wealth_EN_Linear_White from './assets/Full/Manulife-Private-Wealth_EN_Linear/white.svg.js';
import Private_Wealth_EN_Stacked_Black from './assets/Full/Manulife-Private-Wealth_EN_Stacked/black.svg.js';
import Private_Wealth_EN_Stacked_Color from './assets/Full/Manulife-Private-Wealth_EN_Stacked/color.svg.js';
import Private_Wealth_EN_Stacked_Reverse from './assets/Full/Manulife-Private-Wealth_EN_Stacked/reverse.svg.js';
import Private_Wealth_EN_Stacked_White from './assets/Full/Manulife-Private-Wealth_EN_Stacked/white.svg.js';
import Private_Wealth_FR_Linear_Black from './assets/Full/Manulife-Private-Wealth_FR_Linear/black.svg.js';
import Private_Wealth_FR_Linear_Color from './assets/Full/Manulife-Private-Wealth_FR_Linear/color.svg.js';
import Private_Wealth_FR_Linear_Reverse from './assets/Full/Manulife-Private-Wealth_FR_Linear/reverse.svg.js';
import Private_Wealth_FR_Linear_White from './assets/Full/Manulife-Private-Wealth_FR_Linear/white.svg.js';
import Private_Wealth_FR_Stacked_Black from './assets/Full/Manulife-Private-Wealth_FR_Stacked/black.svg.js';
import Private_Wealth_FR_Stacked_Color from './assets/Full/Manulife-Private-Wealth_FR_Stacked/color.svg.js';
import Private_Wealth_FR_Stacked_Reverse from './assets/Full/Manulife-Private-Wealth_FR_Stacked/reverse.svg.js';
import Private_Wealth_FR_Stacked_White from './assets/Full/Manulife-Private-Wealth_FR_Stacked/white.svg.js';
import Private_Wealth_TW_Black from './assets/Full/Manulife-Private-Wealth_TW/black.svg.js';
import Private_Wealth_TW_Color from './assets/Full/Manulife-Private-Wealth_TW/color.svg.js';
import Private_Wealth_TW_Reverse from './assets/Full/Manulife-Private-Wealth_TW/reverse.svg.js';
import Private_Wealth_TW_White from './assets/Full/Manulife-Private-Wealth_TW/white.svg.js';
import Re_Black from './assets/Full/Manulife-Re/black.svg.js';
import Re_Color from './assets/Full/Manulife-Re/color.svg.js';
import Re_Reverse from './assets/Full/Manulife-Re/reverse.svg.js';
import Re_White from './assets/Full/Manulife-Re/white.svg.js';
import Securities_EN_Black from './assets/Full/Manulife-Securities_EN/black.svg.js';
import Securities_EN_Color from './assets/Full/Manulife-Securities_EN/color.svg.js';
import Securities_EN_Reverse from './assets/Full/Manulife-Securities_EN/reverse.svg.js';
import Securities_EN_White from './assets/Full/Manulife-Securities_EN/white.svg.js';
import Securities_FR_Black from './assets/Full/Manulife-Securities_FR/black.svg.js';
import Securities_FR_Color from './assets/Full/Manulife-Securities_FR/color.svg.js';
import Securities_FR_Reverse from './assets/Full/Manulife-Securities_FR/reverse.svg.js';
import Securities_FR_White from './assets/Full/Manulife-Securities_FR/white.svg.js';
import Sinochem_Black from './assets/Full/Manulife-Sinochem/black.svg.js';
import Sinochem_Color from './assets/Full/Manulife-Sinochem/color.svg.js';
import Sinochem_White from './assets/Full/Manulife-Sinochem/white.svg.js';
import Trust_EN_Black from './assets/Full/Manulife-Trust_EN/black.svg.js';
import Trust_EN_Color from './assets/Full/Manulife-Trust_EN/color.svg.js';
import Trust_EN_Reverse from './assets/Full/Manulife-Trust_EN/reverse.svg.js';
import Trust_EN_White from './assets/Full/Manulife-Trust_EN/white.svg.js';
import Trust_FR_Black from './assets/Full/Manulife-Trust_FR/black.svg.js';
import Trust_FR_Color from './assets/Full/Manulife-Trust_FR/color.svg.js';
import Trust_FR_Reverse from './assets/Full/Manulife-Trust_FR/reverse.svg.js';
import Trust_FR_White from './assets/Full/Manulife-Trust_FR/white.svg.js';
import SquareGreen from './assets/Square/green.svg.js';
import SquareWhite from './assets/Square/white.svg.js';
import Wordmark_EN_Black from './assets/Wordmark/Manulife_EN/black.svg.js';
import Wordmark_EN_White from './assets/Wordmark/Manulife_EN/white.svg.js';
import Wordmark_FR_Black from './assets/Wordmark/Manulife_FR/black.svg.js';
import Wordmark_FR_White from './assets/Wordmark/Manulife_FR/white.svg.js';
import HK_Wordmark_Linear_Black from './assets/Wordmark/Manulife_HK_Linear/black.svg.js';
import HK_Wordmark_Linear_White from './assets/Wordmark/Manulife_HK_Linear/white.svg.js';
import HK_Wordmark_Stacked_Black from './assets/Wordmark/Manulife_HK_Stacked/black.svg.js';
import HK_Wordmark_Stacked_White from './assets/Wordmark/Manulife_HK_Stacked/white.svg.js';
import JP_Wordmark_Linear_Black from './assets/Wordmark/Manulife_JP_Linear/black.svg.js';
import JP_Wordmark_Linear_White from './assets/Wordmark/Manulife_JP_Linear/white.svg.js';
import JP_Wordmark_Stacked_Black from './assets/Wordmark/Manulife_JP_Stacked/black.svg.js';
import JP_Wordmark_Stacked_White from './assets/Wordmark/Manulife_JP_Stacked/white.svg.js';
import Bank_Wordmark_EN_Black from './assets/Wordmark/Manulife-Bank_EN/black.svg.js';
import Bank_Wordmark_EN_White from './assets/Wordmark/Manulife-Bank_EN/white.svg.js';
import Bank_Wordmark_FR_Black from './assets/Wordmark/Manulife-Bank_FR/black.svg.js';
import Bank_Wordmark_FR_White from './assets/Wordmark/Manulife-Bank_FR/white.svg.js';
import CoverMe_Wordmark_EN_Black from './assets/Wordmark/Manulife-CoverMe_EN/black.svg.js';
import CoverMe_Wordmark_EN_White from './assets/Wordmark/Manulife-CoverMe_EN/white.svg.js';
import CoverMe_Wordmark_FR_Black from './assets/Wordmark/Manulife-CoverMe_FR/black.svg.js';
import CoverMe_Wordmark_FR_White from './assets/Wordmark/Manulife-CoverMe_FR/white.svg.js';
import IM_Wordmark_CN_Black from './assets/Wordmark/Manulife-IM_CN/black.svg.js';
import IM_Wordmark_CN_White from './assets/Wordmark/Manulife-IM_CN/white.svg.js';
import IM_Wordmark_EN_Linear_Black from './assets/Wordmark/Manulife-IM_EN_Linear/black.svg.js';
import IM_Wordmark_EN_Linear_White from './assets/Wordmark/Manulife-IM_EN_Linear/white.svg.js';
import IM_Wordmark_EN_Stacked_Black from './assets/Wordmark/Manulife-IM_EN_Stacked/black.svg.js';
import IM_Wordmark_EN_Stacked_White from './assets/Wordmark/Manulife-IM_EN_Stacked/white.svg.js';
import IM_Wordmark_FR_Linear_Black from './assets/Wordmark/Manulife-IM_FR_Linear/black.svg.js';
import IM_Wordmark_FR_Linear_White from './assets/Wordmark/Manulife-IM_FR_Linear/white.svg.js';
import IM_Wordmark_FR_Stacked_Black from './assets/Wordmark/Manulife-IM_FR_Stacked/black.svg.js';
import IM_Wordmark_FR_Stacked_White from './assets/Wordmark/Manulife-IM_FR_Stacked/white.svg.js';
import IM_Wordmark_JP_Black from './assets/Wordmark/Manulife-IM_JP/black.svg.js';
import IM_Wordmark_JP_White from './assets/Wordmark/Manulife-IM_JP/white.svg.js';
import IM_Wordmark_TW_Black from './assets/Wordmark/Manulife-IM_TW/black.svg.js';
import IM_Wordmark_TW_White from './assets/Wordmark/Manulife-IM_TW/white.svg.js';
import Private_Wealth_Wordmark_CN_Black from './assets/Wordmark/Manulife-Private-Wealth_CN/black.svg.js';
import Private_Wealth_Wordmark_CN_White from './assets/Wordmark/Manulife-Private-Wealth_CN/white.svg.js';
import Private_Wealth_Wordmark_EN_Linear_Black from './assets/Wordmark/Manulife-Private-Wealth_EN_Linear/black.svg.js';
import Private_Wealth_Wordmark_EN_Linear_White from './assets/Wordmark/Manulife-Private-Wealth_EN_Linear/white.svg.js';
import Private_Wealth_Wordmark_EN_Stacked_Black from './assets/Wordmark/Manulife-Private-Wealth_EN_Stacked/black.svg.js';
import Private_Wealth_Wordmark_EN_Stacked_White from './assets/Wordmark/Manulife-Private-Wealth_EN_Stacked/white.svg.js';
import Private_Wealth_Wordmark_FR_Linear_Black from './assets/Wordmark/Manulife-Private-Wealth_FR_Linear/black.svg.js';
import Private_Wealth_Wordmark_FR_Linear_White from './assets/Wordmark/Manulife-Private-Wealth_FR_Linear/white.svg.js';
import Private_Wealth_Wordmark_FR_Stacked_Black from './assets/Wordmark/Manulife-Private-Wealth_FR_Stacked/black.svg.js';
import Private_Wealth_Wordmark_FR_Stacked_White from './assets/Wordmark/Manulife-Private-Wealth_FR_Stacked/white.svg.js';
import Private_Wealth_Wordmark_TW_Black from './assets/Wordmark/Manulife-Private-Wealth_TW/black.svg.js';
import Private_Wealth_Wordmark_TW_White from './assets/Wordmark/Manulife-Private-Wealth_TW/white.svg.js';
import Re_Wordmark_Black from './assets/Wordmark/Manulife-Re/black.svg.js';
import Re_Wordmark_White from './assets/Wordmark/Manulife-Re/white.svg.js';
import Securities_Wordmark_EN_Black from './assets/Wordmark/Manulife-Securities_EN/black.svg.js';
import Securities_Wordmark_EN_White from './assets/Wordmark/Manulife-Securities_EN/white.svg.js';
import Securities_Wordmark_FR_Black from './assets/Wordmark/Manulife-Securities_FR/black.svg.js';
import Securities_Wordmark_FR_White from './assets/Wordmark/Manulife-Securities_FR/white.svg.js';
import Trust_Wordmark_EN_Black from './assets/Wordmark/Manulife-Trust_EN/black.svg.js';
import Trust_Wordmark_EN_White from './assets/Wordmark/Manulife-Trust_EN/white.svg.js';
import Trust_Wordmark_FR_Black from './assets/Wordmark/Manulife-Trust_FR/black.svg.js';
import Trust_Wordmark_FR_White from './assets/Wordmark/Manulife-Trust_FR/white.svg.js';

// Manulife Default
const ManulifeFr = {
  BLACK: FR_Black,
  COLOR: FR_Color,
  REVERSE: FR_Reverse,
  WHITE: FR_White,
  WORDMARK_BLACK: Wordmark_FR_Black,
  WORDMARK_WHITE: Wordmark_FR_White
};
const HkLinear = {
  BLACK: HK_Linear_Black,
  COLOR: HK_Linear_Color,
  REVERSE: HK_Linear_Reverse,
  WHITE: HK_Linear_White,
  WORDMARK_BLACK: HK_Wordmark_Linear_Black,
  WORDMARK_WHITE: HK_Wordmark_Linear_White
};
const HkStacked = {
  BLACK: HK_Stacked_Black,
  COLOR: HK_Stacked_Color,
  REVERSE: HK_Stacked_Reverse,
  WHITE: HK_Stacked_White,
  WORDMARK_BLACK: HK_Wordmark_Stacked_Black,
  WORDMARK_WHITE: HK_Wordmark_Stacked_White
};
const JpLinear = {
  BLACK: JP_Linear_Black,
  COLOR: JP_Linear_Color,
  REVERSE: JP_Linear_Reverse,
  WHITE: JP_Linear_White,
  WORDMARK_BLACK: JP_Wordmark_Linear_Black,
  WORDMARK_WHITE: JP_Wordmark_Linear_White
};
const JpStacked = {
  BLACK: JP_Stacked_Black,
  COLOR: JP_Stacked_Color,
  REVERSE: JP_Stacked_Reverse,
  WHITE: JP_Stacked_White,
  WORDMARK_BLACK: JP_Wordmark_Stacked_Black,
  WORDMARK_WHITE: JP_Wordmark_Stacked_White
};
const BankEn = {
  BLACK: Bank_EN_Black,
  COLOR: Bank_EN_Color,
  REVERSE: Bank_EN_Reverse,
  WHITE: Bank_EN_White,
  WORDMARK_BLACK: Bank_Wordmark_EN_Black,
  WORDMARK_WHITE: Bank_Wordmark_EN_White
};
const BankFr = {
  BLACK: Bank_FR_Black,
  COLOR: Bank_FR_Color,
  REVERSE: Bank_FR_Reverse,
  WHITE: Bank_FR_White,
  WORDMARK_BLACK: Bank_Wordmark_FR_Black,
  WORDMARK_WHITE: Bank_Wordmark_FR_White
};
const CoverMeEn = {
  BLACK: CoverMe_EN_Black,
  COLOR: CoverMe_EN_Color,
  REVERSE: CoverMe_EN_Reverse,
  WHITE: CoverMe_EN_White,
  WORDMARK_BLACK: CoverMe_Wordmark_EN_Black,
  WORDMARK_WHITE: CoverMe_Wordmark_EN_White
};
const CoverMeFr = {
  BLACK: CoverMe_FR_Black,
  COLOR: CoverMe_FR_Color,
  REVERSE: CoverMe_FR_Reverse,
  WHITE: CoverMe_FR_White,
  WORDMARK_BLACK: CoverMe_Wordmark_FR_Black,
  WORDMARK_WHITE: CoverMe_Wordmark_FR_White
};
const InvestmentManagementCn = {
  BLACK: IM_CN_Black,
  COLOR: IM_CN_Color,
  REVERSE: IM_CN_Reverse,
  WHITE: IM_CN_White,
  WORDMARK_BLACK: IM_Wordmark_CN_Black,
  WORDMARK_WHITE: IM_Wordmark_CN_White
};
const InvestmentManagementEnLinear = {
  BLACK: IM_EN_Linear_Black,
  COLOR: IM_EN_Linear_Color,
  REVERSE: IM_EN_Linear_Reverse,
  WHITE: IM_EN_Linear_White,
  WORDMARK_BLACK: IM_Wordmark_EN_Linear_Black,
  WORDMARK_WHITE: IM_Wordmark_EN_Linear_White
};
const InvestmentManagementEnStacked = {
  BLACK: IM_EN_Stacked_Black,
  COLOR: IM_EN_Stacked_Color,
  REVERSE: IM_EN_Stacked_Reverse,
  WHITE: IM_EN_Stacked_White,
  WORDMARK_BLACK: IM_Wordmark_EN_Stacked_Black,
  WORDMARK_WHITE: IM_Wordmark_EN_Stacked_White
};
const InvestmentManagementFrLinear = {
  BLACK: IM_FR_Linear_Black,
  COLOR: IM_FR_Linear_Color,
  REVERSE: IM_FR_Linear_Reverse,
  WHITE: IM_FR_Linear_White,
  WORDMARK_BLACK: IM_Wordmark_FR_Linear_Black,
  WORDMARK_WHITE: IM_Wordmark_FR_Linear_White
};
const InvestmentManagementFrStacked = {
  BLACK: IM_FR_Stacked_Black,
  COLOR: IM_FR_Stacked_Color,
  REVERSE: IM_FR_Stacked_Reverse,
  WHITE: IM_FR_Stacked_White,
  WORDMARK_BLACK: IM_Wordmark_FR_Stacked_Black,
  WORDMARK_WHITE: IM_Wordmark_FR_Stacked_White
};
const InvestmentManagementJp = {
  BLACK: IM_JP_Black,
  COLOR: IM_JP_Color,
  REVERSE: IM_JP_Reverse,
  WHITE: IM_JP_White,
  WORDMARK_BLACK: IM_Wordmark_JP_Black,
  WORDMARK_WHITE: IM_Wordmark_JP_White
};
const InvestmentManagementTw = {
  BLACK: IM_TW_Black,
  COLOR: IM_TW_Color,
  REVERSE: IM_TW_Reverse,
  WHITE: IM_TW_White,
  WORDMARK_BLACK: IM_Wordmark_TW_Black,
  WORDMARK_WHITE: IM_Wordmark_TW_White
};
const PrivateWealthCn = {
  BLACK: Private_Wealth_CN_Black,
  COLOR: Private_Wealth_CN_Color,
  REVERSE: Private_Wealth_CN_Reverse,
  WHITE: Private_Wealth_CN_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_CN_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_CN_White
};
const PrivateWealthEnLinear = {
  BLACK: Private_Wealth_EN_Linear_Black,
  COLOR: Private_Wealth_EN_Linear_Color,
  REVERSE: Private_Wealth_EN_Linear_Reverse,
  WHITE: Private_Wealth_EN_Linear_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_EN_Linear_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_EN_Linear_White
};
const PrivateWealthEnStacked = {
  BLACK: Private_Wealth_EN_Stacked_Black,
  COLOR: Private_Wealth_EN_Stacked_Color,
  REVERSE: Private_Wealth_EN_Stacked_Reverse,
  WHITE: Private_Wealth_EN_Stacked_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_EN_Stacked_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_EN_Stacked_White
};
const PrivateWealthFrLinear = {
  BLACK: Private_Wealth_FR_Linear_Black,
  COLOR: Private_Wealth_FR_Linear_Color,
  REVERSE: Private_Wealth_FR_Linear_Reverse,
  WHITE: Private_Wealth_FR_Linear_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_FR_Linear_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_FR_Linear_White
};
const PrivateWealthFrStacked = {
  BLACK: Private_Wealth_FR_Stacked_Black,
  COLOR: Private_Wealth_FR_Stacked_Color,
  REVERSE: Private_Wealth_FR_Stacked_Reverse,
  WHITE: Private_Wealth_FR_Stacked_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_FR_Stacked_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_FR_Stacked_White
};
const PrivateWealthTw = {
  BLACK: Private_Wealth_TW_Black,
  COLOR: Private_Wealth_TW_Color,
  REVERSE: Private_Wealth_TW_Reverse,
  WHITE: Private_Wealth_TW_White,
  WORDMARK_BLACK: Private_Wealth_Wordmark_TW_Black,
  WORDMARK_WHITE: Private_Wealth_Wordmark_TW_White
};
const Re = {
  BLACK: Re_Black,
  COLOR: Re_Color,
  REVERSE: Re_Reverse,
  WHITE: Re_White,
  WORDMARK_BLACK: Re_Wordmark_Black,
  WORDMARK_WHITE: Re_Wordmark_White
};
const SecuritiesEn = {
  BLACK: Securities_EN_Black,
  COLOR: Securities_EN_Color,
  REVERSE: Securities_EN_Reverse,
  WHITE: Securities_EN_White,
  WORDMARK_BLACK: Securities_Wordmark_EN_Black,
  WORDMARK_WHITE: Securities_Wordmark_EN_White
};
const SecuritiesFr = {
  BLACK: Securities_FR_Black,
  COLOR: Securities_FR_Color,
  REVERSE: Securities_FR_Reverse,
  WHITE: Securities_FR_White,
  WORDMARK_BLACK: Securities_Wordmark_FR_Black,
  WORDMARK_WHITE: Securities_Wordmark_FR_White
};
const Sinochem = {
  BLACK: Sinochem_Black,
  COLOR: Sinochem_Color,
  WHITE: Sinochem_White
};
const TrustEn = {
  BLACK: Trust_EN_Black,
  COLOR: Trust_EN_Color,
  REVERSE: Trust_EN_Reverse,
  WHITE: Trust_EN_White,
  WORDMARK_BLACK: Trust_Wordmark_EN_Black,
  WORDMARK_WHITE: Trust_Wordmark_EN_White
};
const TrustFr = {
  BLACK: Trust_FR_Black,
  COLOR: Trust_FR_Color,
  REVERSE: Trust_FR_Reverse,
  WHITE: Trust_FR_White,
  WORDMARK_BLACK: Trust_Wordmark_FR_Black,
  WORDMARK_WHITE: Trust_Wordmark_FR_White
};
const Square = {
  GREEN: SquareGreen,
  WHITE: SquareWhite
};
var manulife = {
  BLACK: EN_Black,
  COLOR: EN_Color,
  REVERSE: EN_Reverse,
  WHITE: EN_White,
  WORDMARK_BLACK: Wordmark_EN_Black,
  WORDMARK_WHITE: Wordmark_EN_White
};

export { BankEn, BankFr, CoverMeEn, CoverMeFr, HkLinear, HkStacked, InvestmentManagementCn, InvestmentManagementEnLinear, InvestmentManagementEnStacked, InvestmentManagementFrLinear, InvestmentManagementFrStacked, InvestmentManagementJp, InvestmentManagementTw, JpLinear, JpStacked, ManulifeFr, PrivateWealthCn, PrivateWealthEnLinear, PrivateWealthEnStacked, PrivateWealthFrLinear, PrivateWealthFrStacked, PrivateWealthTw, Re, SecuritiesEn, SecuritiesFr, Sinochem, Square, TrustEn, TrustFr, manulife as default };
